"use client";
import AsyncSelect from "@/components/core/selects/AsyncSelect";
import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import useGet from "@/hooks/useGet";
import { Institution } from "@/lib/types/institution";
import { useRouter } from "next/navigation";
import React from "react";

const Filters = ({
  searchParams,
}: {
  searchParams: { institution?: string; search?: string };
}) => {
  const router = useRouter();
//   const { data: institutions } = useGet<Institution[]>(
//     "/career/institutions/all",
//     {
//       queryKey: ["institutions"],
//     }
//   );

  return (
    <>
      <AsyncSelect
        dataSrc="/career/institutions/all"
        labelKey="name"
        placeholder="Filter by institution"
        value={searchParams.institution}
        onValueChange={(value) => {
          router.push(`/careers?institution=${value}`);
        }}
        className="w-fit"
      />
      {/* <Select name="institution" defaultValue={searchParams.institution}>
        <SelectTrigger className="w-full sm:w-[200px]">
          <SelectValue placeholder="Filter by institution" />
        </SelectTrigger>
        <SelectContent>
          {institutions?.map((institution) => (
            <SelectItem key={institution.id} value={institution.id.toString()}>
              {institution.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select> */}
      {/* <Button type="submit" className="w-full sm:w-auto">
        Apply Filters
      </Button> */}
    </>
  );
};

export default Filters;
